import { DateInput as MantineDateInput, DateInputProps as MantineDateInputProps } from "@mantine/dates";

export type DateInputProps = MantineDateInputProps

export const DateInput = (props: DateInputProps) => {
  return <MantineDateInput {...props} />;
};
